import React from 'react';
import MenuSportButton from '../common/menu/MenuSportButton';
import { useFilter } from './by-date/FilterProvider';

export default function Menu(props) {
    const filter = useFilter();
    let sports = props.sports;

    if (filter != null) {
        sports = sports.filter(s => s.filters?.[filter] ?? true != null);
    }

    return (
        <>
            {sports.map(s => {
                return <MenuSportButton key={s.id}
                                        data={s}
                        />;
            })}
        </>    
    );
}
